import React from "react";
import { useSelector } from 'react-redux';
import Dropdown from "../../../../components/Dropdown";


const WorkStyleSection = ({ 
    formData,
    setFormData,
    workingStyleOptions, 
    setDisplay }: any) => {

    const { talent, errors } = useSelector((state: any) => state.talentMypage)

    return (
        <>
            <div className="flex flex-wrap gap-4 items-center mb-2">
              <p className="alu-text-base-2 text-base font-bold">希望する雇用形態</p>
            </div>
            <div className="mt-4">
              <label className="alu-text-base-2 text-sm font-bold mb-2">第一希望</label>
              <Dropdown
                options={workingStyleOptions}
                value={formData.working_style_1}
                onChange={(value: any) => {
                  setFormData((prev) => ({ ...prev, working_style_1: value }));
                  setDisplay(true);
                }}
                placeholder="選択してください"
                inputWidth="full"
                customStyle="mb-4"
              />
              <label className="alu-text-base-2 text-sm font-bold mb-2">第二希望</label>
              <Dropdown
                options={workingStyleOptions}
                value={formData.working_style_2}
                onChange={(value: any) => {
                  setFormData((prev) => ({ ...prev, working_style_2: value }));
                  setDisplay(true);
                }}
                placeholder="選択してください"
                inputWidth="full"
                customStyle="mb-4"
                disabled={!formData.working_style_1 && !formData.working_style_2}
              />
              <label className="alu-text-base-2 text-sm font-bold mb-2">第三希望</label>
              <Dropdown
                options={workingStyleOptions}
                value={formData.working_style_3}
                onChange={(value: any) => {
                  setFormData((prev) => ({ ...prev, working_style_3: value }));
                  setDisplay(true);
                }}
                placeholder="選択してください"
                inputWidth="full"
                disabled={!formData.working_style_2 && !formData.working_style_3}
              />
            </div>
        </>
    )
};

export default WorkStyleSection;